export const GOOGLE_SITE_KEY = '6Le3XKsaAAAAAF6zWv6B12h418HvrzgcQ5wZjtgC';
